import styled from '@emotion/styled';

export const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
`;

export const Title = styled('p')`
  margin-top: 0;
  margin-bottom: 1.3rem;
  font-size: 1.4rem;
  line-height: 1.27;
  font-weight: 700;
  text-align: left;
`;
